<div class="ps-item" [ngClass]="{ 'selected': item.selected }">
	<div class="ps-item-part __button">
		<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
			<g id="plus-grid" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<polygon id="+" points="13.2712871 10.7287129 18 10.7287129 18 13.2712871 13.2712871 13.2712871 13.2712871 18 10.7287129 18 10.7287129 13.2712871 6 13.2712871 6 10.7287129 10.7287129 10.7287129 10.7287129 6 13.2712871 6"></polygon>
			</g>
		</svg>
	</div>
	<div class="ps-item-part __date">
		<span>{{ item.date | date:'shortDate' }}</span>
	</div>
	<div class="ps-item-part __part-number">
		<span [tooltip]="(vendorService.isSeller || vendorService.isAdmin || vendorService.isVendorManager) ? item.vendorName : ''">{{ item.itemCode }}</span>
	</div>
	<div class="ps-item-part">
		<span>{{ item.qty }}</span>
	</div>
	<div class="ps-item-part">
		<span>{{ item.cost | currency:'USD':'symbol-narrow' }}</span>
	</div>
	<div class="ps-item-part __revenue">
		<span>{{ getTotalRevenue() | currency:'USD':'symbol-narrow' }}</span>
	</div>
</div>
